module.exports = __webpack_public_path__ + "img/img.db9c945d.png";